export default __webpack_public_path__ + "static/media/Helm of Rapturous Battle.ec0cf6da.jpg";